import { Accordion } from "radix-ui";

export const AccordionRoot = ({ children, className = "", ...props }) => {
  return (
    <Accordion.Root className={className} {...props}>
      {children}
    </Accordion.Root>
  );
};
